import { AddBtn } from './components/AddBtn';
import Form from './components/Form/Form';
import { LanguageBar } from './components/LanguageBar';
import { ModalWindows } from './components/ModalWindows';
import Sidebar from './components/Sidebar/Sidebar';
import { IWordingsContext, WordingsContext } from '../wordingsState/wordingsContext';
import React, { useContext } from 'react';
import style from './Wordings.module.scss';

const Wordings: React.FC = () => {
	const { groups } = useContext<IWordingsContext>(WordingsContext);

	return (
		<div className={style.container}>
			{groups.length ? (
				<>
					<div className={style.createBtn}>
						<AddBtn />
					</div>
					<div className={style.content}>
						<div className={style.sidebar}>
							<Sidebar />
						</div>
						<div className={style.fields}>
							<div className={style.languageBar}>
								<LanguageBar />
							</div>
							<div className={style.form}>
								<Form />
							</div>
						</div>
					</div>
					<ModalWindows />
				</>
			) : null}
		</div>
	);
};

export default Wordings;
